<template>
    <div class="distribution-index">
        <ul class="module-item-style clearfix distribution-tab">
            <li @click="linkToPage('settingOnlineDistributionRules')" :class="showTab ? 'tabActived' : ''">分配规则</li>
            <li  @click="linkToPage('settingOnlineDistributionSort')" :class="!showTab ? 'tabActived' : ''">客服排序</li>
        </ul>
        <div style="margin-top: 15px;">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'distribution-index',
        data() {
            return {
                distributionRule: '',
                switchBtn: false,
              showTab: false
            }
        },
        watch: {
            '$route'(to, from) {
                if (to.name == 'settingOnlineDistributionRules') {
                    this.showTab = true
                } else {
                    this.showTab = false
                }
            }
        },
        created() {
            // this.getRuleFn()
            // this.getConfig()
            let currentRoute = this.$route.name
            if (currentRoute == 'settingOnlineDistributionRules') {
                this.showTab = true
            } else {
                this.showTab = false
            }
        },
        mounted() {

        },
        methods: {
          linkToPage(pathName){
            this.$router.push(
                    {
                      name: pathName
                    }
            )
          },
            getConfig() {
                this.$http.getConfigAPI().then(res => {
                    if (res.status == 1) {
                        if (res.data.is_open_autodis_admin == 0) {
                            this.switchBtn = false
                        } else if (res.data.is_open_autodis_admin == 1) {
                            this.switchBtn = true
                        }
                    }
                })
            },
            /**
             * 获取设置的规则
             */
            getRuleFn() {
                this.$http.getRulesAPI().then(res => {
                    if (res.status == 1) {
                        this.distributionRule = res.data
                    }
                })
            },
            changeConfig(name) {
                if (this.switchBtn) {
                    this.changeRule(name, '1')
                } else {
                    this.changeRule(name, '0')
                }
            },
            /**
             * 修改规则
             */
            changeRule(name, value) {
                this.$http.saveConfigAPI({
                    name: name,
                    value: value || this.distributionRule,
                }).then(res => {
                    if (res.status == 1) {
                        this.$message({
                            message: res.msg,
                            type: 'success',
                        })
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        })
                    }
                })
            }
        }
    }
</script>

<style lang="scss">
    .distribution-index {
        /*.distribution-rule-title {*/
        /*    line-height: 40px;*/
        /*    color: #333;*/
        /*    margin-top: 20px;*/
        /*}*/

        /*.distribution-rule-container {*/
        /*    .distribution-rule-item {*/
        /*        display: block;*/
        /*        line-height: 30px;*/
        /*        color: #333;*/
        /*        white-space: inherit;*/

        /*        .rule-item-detail {*/
        /*            color: #999;*/
        /*            line-height: 1;*/
        /*            display: block;*/
        /*            padding-left: 23px;*/
        /*        }*/
        /*    }*/
        /*}*/

        /*.isSwitch {*/
        /*    display: flex;*/

        /*    .switch-btn {*/
        /*        margin-left: auto;*/
        /*    }*/
        /*}*/

        .distribution-tab {
            li + li {
                margin-left: 20px;
            }

            li {
                float: left;
                cursor: pointer;
                padding-bottom: 7px;

                &.tabActived {
                    border-bottom: 5px solid #428EFE;
                }
            }
        }
    }
</style>
